import React, { useMemo, useState,useEffect } from 'react'
import {
  Card,
  Row,
  Col,
  Table,
  Select,
  DatePicker,
  Button,
  Statistic,
  Empty,
  Spin,
  message,
  Input,
} from 'antd'
import {
  FileDoneOutlined,
  DollarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from '@ant-design/icons'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import BillService from '../../../../services/Billservice'
import './BillReport.css'
import { notify } from '../../../../components/Customs/NotifyProvider'
import dayjs from 'dayjs'
import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from '../../../../utils/permissionUtils'

const formatBillDateTime = (value, format = 'DD MMM YYYY, hh:mm A') => {
  if (!value) return '-'

  return dayjs(value).format(format)
}


const { RangePicker } = DatePicker


const BillReport = () => {
  const MODULE_KEY = 'bill_report'
  const canView = canViewModule(MODULE_KEY)
  const canCreate = canCreateModule(MODULE_KEY)
  const canUpdate = canUpdateModule(MODULE_KEY)
  const canDelete = canDeleteModule(MODULE_KEY)
  const isViewOnly = canView && !canCreate && !canUpdate && !canDelete
  const [loading, setLoading] = useState(false)
  const [rowsRaw, setRowsRaw] = useState([])
  const [dateFilter, setDateFilter] = useState('today')
  const [range, setRange] = useState(null)
  const [statusFilter, setStatusFilter] = useState('All')
  const [searchText, setSearchText] = useState('')
  

  const buildFilters = () => {
    if (isViewOnly) return { date: 'today' }
    const filters = {}

    if (dateFilter === 'custom' && range && range.length === 2) {
      filters.from = range[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
      filters.to = range[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
    } else if (dateFilter === 'today') {
      filters.date = 'today'
    } else if (dateFilter === 'yesterday') {
      filters.date = 'yesterday'
    }

    if (statusFilter !== 'All') {
      filters.status = statusFilter
    }

    return filters
  }

 const fetchData = async () => {
  if (!canView) return
  setLoading(true)

  try {
    const filters = buildFilters()
    const response = await BillService.getBillReport(filters)

    console.log("🔥 RAW RESPONSE:", response)

    const rows = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
          ? response.data.data
          : []

    console.log("📦 PARSED ROWS:", rows)

    const rowsWithSettings = rows.map((r) => ({
      ...r,
      created_at: r.created_at || r.opened_at || r.open_time || null,
      closed_at: r.closed_at || r.close_time || null,
      settings: r.settings || r.Settings || {} // safe fallback if backend still sends it
    }))

    setRowsRaw(rowsWithSettings)

  } catch (err) {
    console.error("❌ ERROR:", err)
    notify.error(`Failed to load bill report: ${err.message}`)
    setRowsRaw([])
  } finally {
    setLoading(false)
  }
}
  //--auto today dispaly
useEffect(() => {
  fetchData()
}, [])

  const handleClear = () => {
    if (!canUpdate && !canDelete) {
      notify.error('Permission Denied', 'No permission to clear bill report filters')
      return
    }
    setDateFilter('today')
    setRange(null)
    setStatusFilter('All')
    setSearchText('')
    setRowsRaw([])

    
  }

  // const rows = useMemo(() => {
  //   const search = searchText.trim().toLowerCase()

  //   return (rowsRaw || [])
  //     .map((row) => {
  //       const items = Array.isArray(row.items)
  //         ? row.items
  //         : Array.isArray(row.bill_items)
  //         ? row.bill_items
  //         : []

  //       return {
  //         ...row,
  //         key: row.id,
  //         discount: Number(row.discount || 0),
  //         item_count: Number(row.item_count || items.length || 0),
  //         items_total: Number(row.items_total || 0),
  //         final_total: Number(row.final_total || 0),
  //         items,
  //       }
  //     })
  //     .filter((row) => {
  //       if (!search) return true

  //       const childMatch = (row.items || []).some((item) =>
  //         [
  //           item.item_name,
  //           item.name,
  //           item.food_name,
  //           item.menu_name,
  //           String(item.qty),
  //           String(item.price),
  //         ]
  //           .join(' ')
  //           .toLowerCase()
  //           .includes(search)
  //       )

  //       return (
  //         [
  //           row.bill_no,
  //           row.table_name,
  //           row.zone,
  //           row.status,
  //           row.payment_method,
  //           row.note,
  //           String(row.item_count),
  //           String(row.items_total),
  //           String(row.final_total),
  //         ]
  //           .join(' ')
  //           .toLowerCase()
  //           .includes(search) || childMatch
  //       )
  //     })
  // }, [rowsRaw, searchText])
const rows = useMemo(() => {
  const search = searchText.trim().toLowerCase()

  return (rowsRaw || [])
    .map((row) => {
      // ✅ Parse payment_summary
      const payment_summary = (() => {
        const raw = row.payment_summary || row.bill_summary || {}

        if (!raw) return {}

        if (typeof raw === 'string') {
          try {
            return JSON.parse(raw)
          } catch {
            return {}
          }
        }

        return raw
      })()

      const items = Array.isArray(row.items)
        ? row.items
        : Array.isArray(row.bill_items)
        ? row.bill_items
        : []

      let items_total = 0
      let drinks_total = 0

      const updatedItems = items.map((item) => {
        let line_total = 0
        let displayDetails = []

        if (!item?.is_drink) {
          // 🍽️ FOOD
          line_total =
            Number(item?.qty || 0) * Number(item?.price || 0)
        } else {
          // 🍹 DRINK
          try {
            const details = JSON.parse(item?.drink_details || '{}')

            const bottleQty = Number(details.bottle_qty || 0)
            const bottlePrice = Number(details.price_bottle || 0)

            const bottleTotal = bottleQty * bottlePrice

            if (bottleQty > 0) {
              displayDetails.push(
                `Bottle (${bottleQty} × ₹${bottlePrice})`
              )
            }

            let pegTotal = 0

            if (details.pegs && details.peg_qtys) {
              details.pegs.forEach((peg) => {
                const qty = Number(details.peg_qtys[peg.id] || 0)

                if (qty > 0) {
                  displayDetails.push(
                    `${peg.qty}ml Peg (${qty} × ₹${peg.price})`
                  )
                }

                pegTotal += qty * Number(peg.price || 0)
              })
            }

            line_total = bottleTotal + pegTotal
          } catch {
            line_total = 0
          }

          drinks_total += line_total
        }

        items_total += line_total

        return {
          ...item,
          line_total,
          displayDetails,
        }
      })

      // =========================
      // 🍽️ FOOD TOTAL + TAX
      // =========================
      const food_total = updatedItems
        .filter((i) => !i.is_drink)
        .reduce((sum, i) => sum + Number(i.line_total || 0), 0)

      const food_cgst = Number(row.food_cgst || 0)
      const food_sgst = Number(row.food_sgst || 0)

      const items_total_final = food_total + food_cgst + food_sgst

      // =========================
      // 🍹 DRINK TOTAL + TAX
      // =========================
      const drink_cgst = Number(row.drink_cgst || 0)
      const drink_sgst = Number(row.drink_sgst || 0)
      const drink_vat = Number(
        row.drink_vat ?? payment_summary.drink_vat ?? 0
      )

      const drinks_total_final =
        drinks_total + drink_cgst + drink_sgst + drink_vat

      const discount = Number(row.discount || 0)

      const final_total =
        Number(items_total_final) +
        Number(drinks_total_final) -
        discount

      return {
        ...row,
        key: row.id,
        items: updatedItems,

        item_count: Number(row.item_count || updatedItems.length),

        // 🍽️ FOOD
        items_total: items_total_final,

        // 🍹 DRINKS (NOW WITH TAX INCLUDED)
        drinks_total: drinks_total_final,

        final_total,
        discount,

        // 🍽️ FOOD TAX
        food_cgst,
        food_sgst,
        food_discount: Number(row.food_discount || 0),
        food_total: Number(row.food_total || 0),

        // 🍹 DRINK TAX
        drink_cgst,
        drink_sgst,
        drink_vat,
        drink_total: Number(row.drink_total || 0),
      }
    })

    .filter((row) => {
      if (!search) return true

      const childMatch = (row.items || []).some((item) =>
        [
          item.item_name,
          String(item.qty),
          String(item.line_total),
        ]
          .join(' ')
          .toLowerCase()
          .includes(search)
      )

      return (
        [
          row.bill_no,
          row.table_name,
          row.zone,
          row.status,
          row.payment_method,
          String(row.items_total),
          String(row.drinks_total),
          String(row.final_total),
        ]
          .join(' ')
          .toLowerCase()
          .includes(search) || childMatch
      )
    })
}, [rowsRaw, searchText])



  const summary = useMemo(() => {
    const totalBills = rows.length
    const closedBills = rows.filter(
      (r) => String(r.status || '').toLowerCase() === 'closed'
    ).length
    const openBills = rows.filter(
      (r) => String(r.status || '').toLowerCase() !== 'closed'
    ).length
    const totalRevenue = rows.reduce(
      (sum, row) => sum + Number(row.final_total || 0),
      0
    )

    return {
      totalBills,
      closedBills,
      openBills,
      totalRevenue,
    }
  }, [rows])

  const exportRows = useMemo(() => {
    const exportData = []

    rows.forEach((row) => {
      if (!row.items?.length) {
        exportData.push({
          'Bill No': row.bill_no || `BILL-${row.id}`,
          Table: row.table_name || '-',
          Zone: row.zone || '-',
          Status: row.status || '-',
          Payment: row.payment_method || '-',
          Items: row.item_count || 0,
          'Items Total': Number(row.items_total || 0).toFixed(2),
          Discount: Number(row.discount || 0).toFixed(2),
          'Final Total': Number(row.final_total || 0).toFixed(2),
          'Created At': formatBillDateTime(row.created_at),
          'Closed At': formatBillDateTime(row.closed_at),
          'Item Name': '',
          Qty: '',
          Price: '',
          'Line Total': '',
        })
      } else {
        row.items.forEach((item, index) => {
          exportData.push({
            'Bill No': index === 0 ? row.bill_no || `BILL-${row.id}` : '',
            Table: index === 0 ? row.table_name || '-' : '',
            Zone: index === 0 ? row.zone || '-' : '',
            Status: index === 0 ? row.status || '-' : '',
            Payment: index === 0 ? row.payment_method || '-' : '',
            Items: index === 0 ? row.item_count || 0 : '',
            'Items Total':
              index === 0 ? Number(row.items_total || 0).toFixed(2) : '',
            Discount: index === 0 ? Number(row.discount || 0).toFixed(2) : '',
            'Final Total':
              index === 0 ? Number(row.final_total || 0).toFixed(2) : '',
            'Created At':  index === 0 ? formatBillDateTime(row.created_at) : '',
            'Closed At': index === 0 ? formatBillDateTime(row.closed_at) : '',
            'Item Name':
              item.item_name || item.name || item.food_name || item.menu_name || '-',
            Qty: Number(item.qty || 0),
            Price: Number(item.price || 0).toFixed(2),
            'Line Total': Number(
              item.line_total != null
                ? item.line_total
                : Number(item.qty || 0) * Number(item.price || 0)
            ).toFixed(2),
          })
        })
      }
    })

    return exportData
  }, [rows])

  const handleExportExcel = () => {
    if (!exportRows.length) {
      notify.warning('No data to export')
      return
    }

    const worksheet = XLSX.utils.json_to_sheet(exportRows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Bill Report')
    XLSX.writeFile(workbook, 'bill-report.xlsx')
  }
const handleExportPdf = () => {
  if (!rows.length) {
    notify.warning('No data to export')
    return
  }

  const doc = new jsPDF('l', 'mm', 'a4') // Landscape, mm, A4 size

  // Header
  doc.setFontSize(18)
  doc.setTextColor(40, 40, 40)
  doc.setFont(undefined, 'bold')
  doc.text('Bill Report', 14, 15)

  doc.setFontSize(10)
  doc.setFont(undefined, 'normal')
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 21)

  // Prepare table body
  const body = []

  rows.forEach((row) => {
    const itemsText = row.items?.length > 0
      ? row.items
          .map((item) => `• ${item.item_name || item.name || '-'}`)
          .join('\n')
      : '-'

    body.push([
      row.bill_no || `BILL-${row.id}`,
      row.table_name || '-',
      row.zone || '-',
      String(row.status || '-').toUpperCase(),
      row.payment_method || '-',
      row.item_count || 0,
      `Rs.${Number(row.items_total || 0).toFixed(2)}`,
      //`₹${Number(row.drinks_total || 0).toFixed(2)}`,
      `Rs.${Number(row.discount || 0).toFixed(2)}`,
      `Rs.${Number(row.final_total || 0).toFixed(2)}`,
      itemsText,
    ])
  })

  // Generate table
  autoTable(doc, {
    startY: 26,
    head: [[
      'Bill No',
      'Table',
      'Zone',
      'Status',
      'Payment',
      'Items',
      'Items Total',
      //'Drink Total',
      'Discount',
      'Final Total',
      'Items Details',
    ]],
    body: body,
    styles: {
      fontSize: 8,
      cellPadding: 3,
      valign: 'top',
      lineColor: [200, 200, 200],
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [99, 102, 241],
      textColor: 255,
      fontSize: 9,
      fontStyle: 'bold',
      halign: 'center',
    },
    alternateRowStyles: {
      fillColor: [245, 247, 250],
    },
    columnStyles: {
      0: { cellWidth: 42 },  // Bill No
      1: { cellWidth: 20 },  // Table
      2: { cellWidth: 20 },  // Zone
      3: { cellWidth: 20 },  // Status
      4: { cellWidth: 20 },  // Payment
      5: { cellWidth: 16 },  // Items
      6: { cellWidth: 24 },  // Items Total
      7: { cellWidth: 22 },  // Drink Total
      8: { cellWidth: 24 },  // Discount
      9: { cellWidth: 30 },  // Final Total
      10: { cellWidth: 'auto' }, // Items Details
    },
    margin: { left: 10, right: 10, top: 10, bottom: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'avoid',
  })

  // Add footer
  const pageCount = doc.internal.getNumberOfPages()
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.setFontSize(8)
    doc.setTextColor(120, 120, 120)
    doc.text(
      `Page ${i} of ${pageCount}`,
      doc.internal.pageSize.getWidth() - 20,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'center' }
    )
  }

  // Save PDF
  doc.save(`bill-report_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.pdf`)
}




  const childColumns = [
    {
      title: 'Item',
      dataIndex: 'item_name',
      key: 'item_name',
      render: (_, record) => (
        <div className="bill-item-cell">
          <span className="bill-item-dot" />

          <div>
            <div className="bill-item-name">
              {record.item_name || record.name || '-'}
            </div>

            {/*  show drink details */}
            {record.is_drink && record.displayDetails?.length > 0 && (
              <div className="bill-item-sub">
                {record.displayDetails.map((d, i) => (
                  <div key={i}>• {d}</div>
                ))}
              </div>
            )}
          </div>
        </div>
      ),
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      align: 'center',
      // render: (value) => Number(value || 0),
      render: (_, record) => {
        if (!record.is_drink) return Number(record.qty || 0)

        try {
          const details = JSON.parse(record.drink_details || '{}')

          const bottleQty = Number(details.bottle_qty || 0)

          const pegQty =
            details.peg_qtys
              ? Object.values(details.peg_qtys).reduce(
                (sum, q) => sum + Number(q || 0),
                0
              )
              : 0

          return `B:${bottleQty} / P:${pegQty}`
        } catch {
          return '-'
        }
      }
    },
    {
      title: 'Price',
      key: 'price',
      align: 'right',
      render: (_, record) => {
        if (record.is_drink) {
          //  show computed drink total
          return `₹${Number(record.line_total || 0).toFixed(2)}`
        }

        //  normal food price
        return `₹${Number(record.price || 0).toFixed(2)}`
      },
    },
    {
      title: 'Line Total',
      key: 'line_total',
      align: 'right',
      render: (_, record) => {
        // const total =
        //   record.line_total != null
        //     ? Number(record.line_total)
        //     : Number(record.qty || 0) * Number(record.price || 0)
        const total =
          record.line_total != null
            ? Number(record.line_total)
            : Number(record.qty || 0) * Number(record.price || 0)

        return <strong>₹{total.toFixed(2)}</strong>
      },
    },
  ]

  const mainColumns = [
    {
      title: 'Bill No',
      dataIndex: 'bill_no',
      key: 'bill_no',
      render: (value, record) => (
        <div className="bill-main-primary">
          <div className="bill-main-title">
            {value || `BILL-${record.id}`}
          </div>
          {record.note ? (
            <div className="bill-main-subtitle">{record.note}</div>
          ) : null}
        </div>
      ),
    },
    {
      title: 'Table',
      dataIndex: 'table_name',
      key: 'table_name',
      render: (value) => value || '-',
    },
    {
      title: 'Zone',
      dataIndex: 'zone',
      key: 'zone',
      render: (zone) => (
        <span className="bill-zone-pill">{zone || '-'}</span>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const normalized = String(status || '').toLowerCase()
        const isClosed = normalized === 'closed'

        return (
          <span className={`bill-status-pill ${isClosed ? 'closed' : 'open'}`}>
            {normalized ? normalized.toUpperCase() : '-'}
          </span>
        )
      },
    },
    {
      title: 'Payment',
      dataIndex: 'payment_method',
      key: 'payment_method',
      render: (value) => value || '-',
    },
    {
      title: 'Items',
      dataIndex: 'item_count',
      key: 'item_count',
      align: 'center',
      render: (value) => Number(value || 0),
    },
    {
      title: 'Items Total',
      dataIndex: 'items_total',
      key: 'items_total',
      align: 'right',
      render: (value) => `₹${Number(value || 0).toFixed(2)}`,
    },
   {/* {
      title: 'Drinks Total',
      dataIndex: 'drinks_total',
      key: 'drinks_total',
      align: 'right',
      render: (value) => `₹${Number(value || 0).toFixed(2)}`,
    }, */},
    {
      title: 'Discount',
      dataIndex: 'discount',
      key: 'discount',
      align: 'right',
      render: (value) => (
        <span className={Number(value || 0) > 0 ? 'bill-discount-text' : ''}>
          ₹{Number(value || 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: 'Final Total',
      dataIndex: 'final_total',
      key: 'final_total',
      align: 'right',
      render: (value) => (
        <strong className="bill-total-text">
          ₹{Number(value || 0).toFixed(2)}
        </strong>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => (
        <span className="bill-time-text">{formatBillDateTime(value)}</span>
      ),
    },
    {
      title: 'Closed At',
      dataIndex: 'closed_at',
      key: 'closed_at',
      render: (value) => (
        <span className="bill-time-text">{formatBillDateTime(value)}</span>
      ),
    },
  ]

  return !canView ? (
    <Card>
      <Empty description="No permission to view bill report" />
    </Card>
  ) : (
    <div className="bill-report-page">
      <div className="bill-report-hero">
        <div className="bill-report-hero-left">
          <div className="bill-report-hero-icon">
            <FileDoneOutlined />
          </div>
          <div>
            <h2 className="bill-report-hero-title">Bill Report</h2>
            <p className="bill-report-hero-subtitle">
              Modern hotel-style bill analytics with child item details
            </p>
          </div>
        </div>

        <div className="bill-report-hero-actions">
          <Button
            icon={<FileExcelOutlined />}
            onClick={handleExportExcel}
            className="bill-report-export-btn excel"
            disabled={!rows.length || !canCreate}
          >
            Excel
          </Button>
          <Button
            icon={<FilePdfOutlined />}
            onClick={handleExportPdf}
            className="bill-report-export-btn pdf"
            disabled={!rows.length || !canCreate}
          >
            PDF
          </Button>
        </div>
      </div>

      <Card className="bill-report-card">
        <Row gutter={[12, 12]} className="bill-report-filters">
          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              value={dateFilter}
              onChange={setDateFilter}
              disabled={isViewOnly}
              options={[
                { label: 'Today', value: 'today' },
                { label: 'Yesterday', value: 'yesterday' },
                { label: 'All', value: 'all' },
                { label: 'Custom Range', value: 'custom' },
              ]}
            />
          </Col>

          {dateFilter === 'custom' && !isViewOnly && (
            <Col xs={24} sm={12} md={10} lg={7}>
              <RangePicker
                style={{ width: '100%' }}
                value={range}
                onChange={(vals) => setRange(vals)}
              />
            </Col>
          )}

          <Col xs={24} sm={12} md={8} lg={5}>
            <Select
              value={statusFilter}
              onChange={setStatusFilter}
              disabled={isViewOnly}
              options={[
                { label: 'All Status', value: 'All' },
                { label: 'Open', value: 'open' },
                { label: 'Closed', value: 'closed' },
              ]}
            />
          </Col>

          <Col xs={24} sm={12} md={6} lg={3}>
            <Button
              type="primary"
              block
              icon={<ReloadOutlined />}
              className="bill-report-load-btn"
              onClick={fetchData}
              loading={loading}
              disabled={!canView}
            >
              Load
            </Button>
          </Col>

          <Col xs={24} sm={12} md={6} lg={4}>
            <Button
              block
              className="bill-report-clear-btn"
              onClick={handleClear}
              disabled={!canUpdate && !canDelete}
            >
              Clear
            </Button>
          </Col>
        </Row>

        <div className="bill-report-toolbar">
          <Input
            allowClear
            placeholder="Search bills or child items..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="bill-report-search"
          />
        </div>

        <Row gutter={[16, 16]} className="bill-report-stats">
          <Col xs={24} sm={12} md={6}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Bills"
                value={summary.totalBills}
                prefix={<FileDoneOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Closed Bills"
                value={summary.closedBills}
                prefix={<CheckCircleOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Open Bills"
                value={summary.openBills}
                prefix={<ClockCircleOutlined />}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="bill-report-stat-card">
              <Statistic
                title="Total Revenue"
                value={summary.totalRevenue}
                precision={2}
                prefix={<DollarOutlined />}
                formatter={(value) => `₹${Number(value || 0).toFixed(2)}`}
              />
            </Card>
          </Col>
        </Row>

        

        <Spin spinning={loading}>
          {!rows.length ? (
            <div className="bill-report-empty">
              <Empty description="No bill report data found" />
            </div>
          ) : (
            <div className="bill-report-modern-table">
              <Table
                rowKey="id"
                columns={mainColumns}
                dataSource={rows}
                pagination={{ pageSize: 10 }}
                // ✅ Replace ONLY your expandedRowRender block with this updated code
expandable={{
  expandedRowRender: (record) => {

    console.log("FULL RECORD TAX:", record)
  console.log("ITEMS:", record.items)
    const items = record.items || []

    console.log("record___", record);
    

    const foodItems = items.filter((i) => !i.is_drink)
    const drinkItems = items.filter((i) => i.is_drink)

    // 🍽️ FOOD TOTALS
    const foodTotal = foodItems.reduce(
      (sum, i) => sum + Number(i.line_total || 0),
      0
    )

    const foodQty = foodItems.reduce(
      (sum, i) => sum + Number(i.qty || 0),
      0
    )

    const foodCGST = foodItems.reduce(
  (sum, i) => sum + Number(i.item_cgst_amount || 0),
  0
)

const foodSGST = foodItems.reduce(
  (sum, i) => sum + Number(i.item_sgst_amount || 0),
  0
)
    const foodDiscount = Number(record.food_discount || 0)
    const foodFinal = Number(record.food_total || foodTotal)

    // 🍹 DRINK TOTALS
    const drinkTotal = drinkItems.reduce(
      (sum, i) => sum + Number(i.line_total || 0),
      0
    )

    const drinkQty = drinkItems.length

     const drinkCGST = drinkItems.reduce(
  (sum, i) => {
    const line = Number(i.line_total || 0)
    const pct = Number(i.drink_cgst_pct || 0) / 100
    return sum + line * pct
  },
  0
)

const drinkSGST = drinkItems.reduce(
  (sum, i) => {
    const line = Number(i.line_total || 0)
    const pct = Number(i.drink_sgst_pct || 0) / 100
    return sum + line * pct
  },
  0
)
    const drinkVAT = Number(record.drink_vat || 0)
    const drinkFinal = Number(record.drink_total || drinkTotal)

    return (
      <div className="bill-report-nested-wrap">

        {/* ================= SUMMARY ================= */}
        <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>

          {/* 🍽️ FOOD */}
          {foodQty > 0 && (
          <Col xs={24} md={12}>
            <Card size="small" title="🍽️ Food Summary">

              <p>Total Qty: <b>{foodQty}</b></p>

              <p>Total Amount: <b>₹{Number(foodTotal || 0).toFixed(2)}</b></p>
               

               {foodCGST > 0 && (
              <p>CGST: <b>₹{foodCGST.toFixed(2)}</b></p>
               )}

               { foodSGST > 0 && (

              <p>SGST: <b>₹{foodSGST.toFixed(2)}</b></p>

              )}

            </Card>
          </Col>
          )}

          {/* 🍹 DRINK */}
        {/*  {drinkQty > 0 && (
          <Col xs={24} md={12}>
            <Card size="small" title="🍹 Drink Summary">

              <p>Total Qty: <b>{drinkQty}</b></p>

              <p>Total Amount: <b>₹{drinkTotal.toFixed(2)}</b></p>
               

               {drinkCGST > 0 && (
              <p>CGST: <b>₹{drinkCGST.toFixed(2)}</b></p>
               )}
              
                {drinkSGST > 0 &&(
              <p>SGST: <b>₹{drinkSGST.toFixed(2)}</b></p>

              )}
               {drinkVAT > 0 && (
              <p>Vat (in %): <b>₹{drinkVAT.toFixed(2)}</b></p>
               )}
            </Card>
          </Col>
          )}   */}

        </Row>

        {/* ================= ITEM TABLE ================= */}
        <div className="bill-report-nested-head">
          <span>Items for {record.bill_no}</span>
          <span>{items.length} items</span>
        </div>

        <Table
          rowKey={(item) => `${record.id}-${item.item_name}-${item.qty}-${item.price}`}
          columns={childColumns}
          dataSource={items}
          pagination={false}
          size="small"
          locale={{ emptyText: 'No item rows found' }}
        />

      </div>
    )
  },

  rowExpandable: (record) =>
    Array.isArray(record.items) && record.items.length > 0,
}}
              />
            </div>
          )}
        </Spin>
      </Card>
    </div>
  )
}

export default BillReport
